import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import logo from '../assets/polonsky-academy-logo.png';
import { auth } from '../firebase';
import { onAuthStateChanged, User } from 'firebase/auth';
import AccountCenter from './AccountCenter';

const Navbar = () => {
  const [user, setUser] = useState<User | null>(null);
  const [showAccountCenter, setShowAccountCenter] = useState(false);
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);
  const closeMobileMenu = () => setIsNavCollapsed(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  const getUserInitials = (user: User) => {
    if (user.displayName) {
      const names = user.displayName.split(' ');
      return (names[0][0] + (names.length > 1 ? names[names.length - 1][0] : '')).toUpperCase();
    }
    return user.email ? user.email.charAt(0).toUpperCase() : '?';
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-white">
        <div className="container">
          {/* Brand and Toggler are grouped for better mobile display */}
          <Link className="navbar-brand navbar-brand-mobile" to="/" onClick={closeMobileMenu}>
            <img src={logo} alt="Polonsky Academy Logo" style={{ height: '60px' }} />
          </Link>
          <button className="navbar-toggler" type="button" onClick={handleNavCollapse} aria-expanded={!isNavCollapsed}>
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Collapsible content */}
          <div className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse`} id="navbarNav">
            {/* Centered nav links */}
            <ul className="navbar-nav mx-auto">
              <li className="nav-item">
                <NavLink className="nav-link" to="/" end onClick={closeMobileMenu}>Home</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/chess" onClick={closeMobileMenu}>Chess</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/dance" onClick={closeMobileMenu}>Dance</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/coaches" onClick={closeMobileMenu}>Coaches</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/contact" onClick={closeMobileMenu}>Contact Us</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/blog" onClick={closeMobileMenu}>Blog</NavLink>
              </li>
            </ul>

            {/* Right-aligned buttons, now part of the main flow */}
            <div className="navbar-right-buttons d-flex align-items-center">
              <Link to="/book/free-trial" className="btn btn-success me-3" onClick={closeMobileMenu}>Book Now!</Link>
              {user ? (
                <div className="nav-item">
                  <button className="nav-link d-flex align-items-center" onClick={() => { closeMobileMenu(); setShowAccountCenter(true); }} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
                    <div style={{
                      width: '45px', height: '45px', borderRadius: '50%', backgroundColor: '#007bff',
                      color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center',
                      fontWeight: 'bold', fontSize: '1.2rem'
                    }}>
                      {getUserInitials(user)}
                    </div>
                  </button>
                </div>
              ) : (
                <Link to="/login" className="nav-link" onClick={closeMobileMenu}>
                  <i className="fas fa-user me-1"></i>
                  Log In
                </Link>
              )}
            </div>
          </div>
        </div>
      </nav>
      {showAccountCenter && user && <AccountCenter user={user} onClose={() => setShowAccountCenter(false)} />}
    </>
  );
};

export default Navbar;